import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer";
import { useAuthScope } from "../hooks/useAuthClaims";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { loadBookStats } from "../store/slices/bookStatsSlice";
import {
    fetchLatestChapters,
    fetchSubscribedChapters,
} from "../store/slices/latestChaptersSlice";

function PageLayout({ children }) {
    const dispatch = useDispatch();
    const location = useLocation();
    const { t } = useTranslation();

    const authScope = useAuthScope();
    const { isResolved, isLoggedIn } = useSelector((s) => s.auth);
    const lastUpdated = useSelector((s) => s.bookStats.lastUpdated);

    const isReaderPage =
        /^\/\d+\/\d+$/.test(location.pathname) ||
        /^\/reader\/book\/[^/]+\/chapter\/[^/]+$/.test(location.pathname);

    const isTranslatorPage = /^\/translator\/\d+\/\d+$/.test(location.pathname);
    const isMessagesPage = location.pathname.startsWith("/messages");
    const isReaderArray = isReaderPage && Array.isArray(children);

    useEffect(() => {
        if (!isResolved) return;
        dispatch(fetchLatestChapters(t));
    }, [isResolved, dispatch, t]);

    useEffect(() => {
        if (isResolved && isLoggedIn) {
            dispatch(fetchSubscribedChapters(t));
        }
    }, [isResolved, isLoggedIn, authScope, dispatch, t]);

    useEffect(() => {
        const fetchLatest = () => {
            dispatch(fetchLatestChapters(t));
        };

        const timer = setInterval(fetchLatest, 10 * 60 * 1000);

        const onVis = () => {
            if (!document.hidden) {
                fetchLatest();
            }
        };

        document.addEventListener("visibilitychange", onVis);

        return () => {
            document.removeEventListener("visibilitychange", onVis);
            clearInterval(timer);
        };
    }, [dispatch, t]);

    useEffect(() => {
        dispatch(loadBookStats({ t }));
    }, [dispatch, t, lastUpdated]);

    const hideNavbar = isReaderPage || isTranslatorPage;
    const hideFooterDesktop = isReaderPage || isTranslatorPage;
    const hideFooterOnMobileMessages = isMessagesPage;

    return (
        <div className="flex flex-col min-h-screen bg-black">
            {!hideNavbar && <Navbar />}

            <main className="flex-1">
                {isReaderArray ? (
                    <>
                        {children[0]}
                        {children[1]}
                    </>
                ) : (
                    children
                )}
            </main>

            {!hideFooterDesktop && (
                <>
                    <div className={hideFooterOnMobileMessages ? "hidden md:block" : "block"}>
                        <Footer />
                    </div>

                    {!hideFooterOnMobileMessages && (
                        <div className="h-[60px] md:hidden" />
                    )}
                </>
            )}
        </div>
    );
}

export default PageLayout;
